export const PACKAGE_SUBMIT_MODELING_STOCK_MESSAGE = "该套餐订单的配件库存不足，请联系客服";

const INVENTORY_ERROR_PATTERNS = [
	"套餐配件库存不足",
	"不存在库存记录",
	"库存记录不存在",
	"可用库存不足"
];

const PACKAGE_OUTBOUND_CONTEXT_PATTERNS = ["创建套餐出库申请失败", "无法创建出库单", "套餐订单"];

export function isPackageSubmitModelingStockError(message = "") {
	const text = String(message || "").trim();
	if (!text) {
		return false;
	}

	if (text.includes("套餐配件库存不足")) {
		return true;
	}

	const hasInventoryError = INVENTORY_ERROR_PATTERNS.some((pattern) => text.includes(pattern));
	if (!hasInventoryError) {
		return false;
	}

	return PACKAGE_OUTBOUND_CONTEXT_PATTERNS.some((pattern) => text.includes(pattern));
}

export function normalizeSubmitModelingErrorMessage(message = "") {
	const text = String(message || "").trim();
	if (!text) {
		return "";
	}

	if (isPackageSubmitModelingStockError(text)) {
		return PACKAGE_SUBMIT_MODELING_STOCK_MESSAGE;
	}

	return text;
}

export function getSubmitModelingErrorMessage(errorLike, fallback = "") {
	const rawMessage =
		errorLike?.message?.$t ||
		errorLike?.message ||
		errorLike?.$t ||
		errorLike?.msg ||
		fallback;

	return normalizeSubmitModelingErrorMessage(rawMessage || fallback || "");
}
